import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import relativeTime from 'dayjs/plugin/relativeTime'
import timezone from 'dayjs/plugin/timezone'
// @ts-ignore
import { Ref } from '#imports'


dayjs.extend(utc)
dayjs.extend(relativeTime)
dayjs.extend(timezone)
dayjs.tz.setDefault('utc')

export { dayjs }

export const getCurrentUTCTimestamp = () => {
	return dayjs.utc().unix()
}

export const getTimeZone = function () {
	return Intl.DateTimeFormat().resolvedOptions().timeZone
}

export const getWeekDayNumber = (value: string | Date, firstDayOfWeek: 'm' | 's' = 'm'): number => {
	if (typeof value === 'string')
		value = new Date(value)
	if (firstDayOfWeek === 'm')
		return (value.getDay() + 6) % 7
	return value.getDay()
}

export const getWeekdayName = (
	value: number | string | Date,
	locale: string = 'de-DE',
	format: 'long' | 'short' = 'long',
	firstDayOfWeek: 'm' | 's' = 'm'
): string => {
	const dates: string[] = [
		'1970-01-05',
		'1970-01-06',
		'1970-01-07',
		'1970-01-01',
		'1970-01-02',
		'1970-01-03',
	]
	if (typeof value === 'number') {
		firstDayOfWeek === 'm'
			? dates.push('1970-01-04')
			: dates.unshift('1970-01-04')
		// @ts-ignore
		value = dates[value]
	}
	return new Intl.DateTimeFormat(locale, {'weekday': format}).format(typeof value === 'string' ? new Date(value) : value)
}

export const getWeekdayChoices = (locale: Ref | string, firstDayOfWeek: 's' | 'm' = 'm') => {
	let results = []
	for (let i = 0; i < 7; i++)
		results.push({
			value: i,
			label: getWeekdayName(i, typeof locale === 'string' ? locale : locale.value, 'long', firstDayOfWeek)
		})
	return results
}

export const getMonthChoices = (
	locale: string = 'de-DE',
	format: 'long' | 'short' = 'long'
): {value: number, label: string}[] => {
	let months = []
	for (let i = 1; i < 13; i++) {
		months.push({
			value: i,
			label: new Intl.DateTimeFormat(locale, {month: format}).format(
				new Date(`1977-${i < 10 ? '0'+i : i}-01`)
			)
		})
	}
	return months
}


export function timeToInt(value: string): number {
	// funktioniert auch so in python
	return dayjs(`1970-01-01T${value}Z`).utc().unix()
}

export function intToTime(value: number, seconds: boolean = false): string {
	return dayjs.unix(value).utc().format(seconds ? 'HH:mm:ss' : 'HH:mm')
}

export function toISOTime(time: string, utc: boolean = true) {
	return utc
		? dayjs('1970-01-01T' + time).utc().format('HH:mm:ss[Z]')
		: dayjs('1970-01-01T' + time).format('HH:mm:ssZ')
}

export function formatTime(time: string, locale: string | Ref = 'de', style: 'short' | 'medium' | 'long' | null = null) {
	if (!time)
		return ''
	if (!time.startsWith('T'))
		time = 'T'+time
	return new Date('1970-01-01'+time).toLocaleTimeString(typeof locale === 'string' ? locale : locale.value, style ? {timeStyle: style} : undefined)
}

export function getTimezone(v: Date | string | undefined = undefined, locale: string = 'de') {
	if (!dayjs(v).isValid()) {
		if (dayjs('1970-01-01'+v).isValid())
			v = '1970-01-01'+v
		else if (dayjs('1970-01-01T'+v).isValid())
			v = '1970-01-01T'+v
	}
	// @ts-ignore
	return new Intl.DateTimeFormat(locale, {timeZoneName: 'short'})
		.formatToParts(typeof v === 'string' ? new Date(v) : v)
		.find(part => part.type === 'timeZoneName').value  //.resolvedOptions().timeZone
}
